import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { LoginModal } from 'lib/shared'
import { ExtraText } from './styled'

export const LoggedOutModal = () => {
  const { logout, isSessionEndedDueInvalidToken } = useCustomer()
  const history = useHistory()
  const [loggedOutModalVisible, setLoggedOutModalVisible] = useState(false)

  useEffect(() => {
    if (isSessionEndedDueInvalidToken) {
      setLoggedOutModalVisible(true)
    }
  }, [isSessionEndedDueInvalidToken])

  return (
    <LoginModal
      handleCloseModal={() => {
        setLoggedOutModalVisible(false)
        logout()
        history.push('/')
      }}
      isOpen={loggedOutModalVisible}
      afterTitle={(
        <ExtraText>
          <FormattedMessage
            id='customer.account.login.error.title'
          />
        </ExtraText>
      )}
      onLoginSuccess={() => setLoggedOutModalVisible(false)}
    />
  )
}
